import { css } from '@emotion/react';

import { MediaBP as MQ } from 'src/styles/mediaQuery';

export const scoreBoardAdImg = css`
  padding-bottom: 16px;
  ${MQ.MediaMd} {
    padding-bottom: 16px;
  }
  ${MQ.MediaLg} {
    padding-bottom: 16px;
  }
`;

export const matchScheduleAdImg = css`
  ${MQ.MediaMd} {
    max-width: 92%;
  }
  ${MQ.MediaLg} {
    max-width: 70%;
    padding-top: 16px;
    margin: 0;
  }
`;

export const sportsVodAds = css`
  padding-bottom: 16px;
  ${MQ.MediaMd} {
    padding-bottom: 16px;
  }
  ${MQ.MediaLg} {
    padding-bottom: 16px;
  }
`;

export const teamVideosAds = css`
  padding-bottom: 16px;
  ${MQ.MediaMd} {
    padding-bottom: 16px;
  }
  ${MQ.MediaLg} {
    padding-bottom: 16px;
  }
`;

export const teamSquadAds = css`
  padding-bottom: 16px;
  ${MQ.MediaMd} {
    padding-bottom: 16px;
  }
  ${MQ.MediaLg} {
    padding-bottom: 16px;
  }
`;

export const adContainer = css`
  margin: auto;
  text-align: center;
  position: relative;
  padding-top: 16px;

  .adImage > div > iframe {
    margin-top: 10px;

    ${MQ.MediaLg} {
      margin-top: 0px;
    }
  }
`;
